
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";
import TemplateOptions from "@/module/main/page/TemplateOptionsEnum";
import TemplateOptionsEnum from "@/module/main/page/TemplateOptionsEnum";
import IBlock3Others from "@/module/main/model/applicationForm/IBlock3Others";
import SecondaryDocumentType from "@/module/main/dto/customer/SecondaryDocumentTypeEnum";
import YesNo from "@/app/service/YesNoEnum";
import { EnumUtil } from "@/app";
import AcademicCardType from "@/module/main/dto/customer/AcademicCardTypeEnum";

@Component
export default class Block3Others extends HcPageModel {
    @Prop({type: Object}) public value!: IBlock3Others;
    @Prop({type: String}) public template!: TemplateOptions;

    protected pageName: string = "block3-others";

    private get isCzTemplate(): boolean {
        return this.template === TemplateOptionsEnum.CZ;
    }

    private get showAcademicCardFields(): boolean {
        return this.value.secondaryDocumentType === SecondaryDocumentType.ACADEMIC_CARD;
    }

    private get secondaryDocumentTypeData(): object[] {
        return EnumUtil.createSelectDataFromEnum(SecondaryDocumentType, "SecondaryDocumentType", true);
    }

    private get politicallyExposedData(): object[] {
        return EnumUtil.createSelectDataFromEnum(YesNo, "YesNo", true);
    }

    private get academicCardTypeData(): object[] {
        return EnumUtil.createSelectDataFromEnum(AcademicCardType, "AcademicCardType", true);
    }
}
